export default [{
    name: 'На территории объекта',
    key: 'internal',
}, {
    name: 'За территорией объекта',
    key: 'external',
}];
